import {_} from 'lodash';
import * as ko from "knockout";
import {IObjectData, IRouteDefinitionParams, ISyncField} from "../../index";
import {AbstractWizard, ISyncFieldMutable, template as tpl} from "./AbstractWizard";
import PromiseRequest from "../../req/PromiseRequest";
import {global} from "../../appContext";
import {nsWizard} from "./nsWizard";
import {getRawSyncFieldValue, getSyncField, isNullOrUndefined} from "../../util/misc";
import {REQUEST_MESSAGE, UPDATING_MESSAGE} from "../../constants/Language";
import {Syncfield_Group, TSyncfield_Group} from "../../constants/Syncfields";
import {getHash} from "../../constants/RouteDefinitions";
import Syncfield_mandatory = nsWizard.Syncfield_mandatory;
import Syncfield_optional = nsWizard.Syncfield_optional;

export const template = tpl;

export class viewModel extends AbstractWizard {
    private readonly req_getobject: PromiseRequest = global.getPromiseRequest('getobject');
    protected readonly req_submit = global.getPromiseRequest("updateobject")

    constructor(params: IRouteDefinitionParams) {
        super(params)
        this.init()
    }

    protected override init(): Promise<void> {
        this.step(null);
        this.messageData({message: REQUEST_MESSAGE});

        return Promise
            .resolve()
            .then(() => this.req_getobject
                .request({
                    id: this.__id,
                    manual: true,
                })
                .then((data: [IObjectData]) => {
                    this.data = data[0]
                    this.groupLink = getHash('manualgroupdetails', {id: data[0].id}) ?? ''
                })
                .catch(this.onRequestError.bind(this))
            )
            .then(() => super.init())
            .then(() => this.resetSyncfields())
            .then(() => {
                this.messageData(null)
                this.step(0)
            })
            .catch(this.onRequestError.bind(this))
    }

    protected resetSyncfields(): void {
        [...Syncfield_mandatory, ...Syncfield_optional].forEach(key => {
            const value = getRawSyncFieldValue(key, this.data.syncfields);
            if (!isNullOrUndefined(value)) {
                const mutable = this.produceMutable(key)
                mutable.value(value ?? null)
            }
        })
    }

    protected override _generateMutable(key: TSyncfield_Group): ISyncFieldMutable {
        const isMandatory = Syncfield_mandatory.includes(key)
        return {
            id: ko.observable(null),
            mandatory: isMandatory,
            name: key,
            syncfield: this.data.syncfields.find(o => o.name == key) as ISyncField<TSyncfield_Group>,
            value: ko.observable(null),
        }
    }

    protected onSubmit() {
        const data = this.getSubmitData();
        this.messageData({message: UPDATING_MESSAGE});
        this.req_submit.abort()
        return this.req_submit
            .request({jobject: JSON.stringify(data)})
            .then(this.onSubmitSuccess.bind(this))
            .then(() => this.messageData({message: `subject is updated|s:((manual group))`}))
            .catch(this.onRequestError.bind(this))
    }

    protected getSubmitData(): IObjectData {
        const ret = _.cloneDeep(this.data)
        ret.syncfields = this.getSubmitSyncfields()
        return ret
    }

    protected getSubmitSyncfields(): ISyncField[] {
        const syncfields: ISyncField[] = Syncfield_Group.map(name => {
            const mutable = this.getMutable(name);
            const original = getSyncField(name, this.data.syncfields)
            const sf = mutable?.syncfield ?? original
            if (!sf) {
                throw new Error(`Missing syncfield ${name}`)
            }
            sf.value = this.getSubmitValue(name) ?? ''
            return sf
        })
        const include: TSyncfield_Group[] = [...Syncfield_mandatory, ...Syncfield_optional];
        const exclude: TSyncfield_Group[] = Syncfield_Group.filter(k => !include.includes(k))
        exclude.forEach(k => {
            const index = syncfields.findIndex(sf => sf.name == k)
            syncfields.splice(index, 1)
        })
        return syncfields
    }

    private showSourceIdWarning(): boolean {
        const sfm = this.produceMutable('SourceId');
        return sfm.value() != sfm.syncfield?.value
    }

    override dispose() {
        super.dispose()
        this.req_getobject.abort()
    }

}
